import { useEffect, useState } from 'react';
import { ServiceProcedure } from '../../types/companyResourceTypes';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteServiceProcedureModalProps {
    item: ServiceProcedure | null;
    linkedCount?: number;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteServiceProcedureModal = ({
    item,
    linkedCount = 0,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteServiceProcedureModalProps) => {
    const visible = Boolean(item?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, item?.id]);

    const itemName = item?.itemName?.trim() || item?.category?.trim() || 'this procedure';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete procedure?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to permanently delete <strong>“{itemName}”</strong>. This cannot be undone.
            </p>
            <p>
                Linked consumables are unlinked only; they remain on Service Items.
            </p>
            {linkedCount > 0 && (
                <p>
                    {linkedCount} linked consumable{linkedCount === 1 ? '' : 's'} will be unlinked.
                </p>
            )}
        </CustomModal>
    );
};
